import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection, limit, documentId } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import { Helmet } from "react-helmet";
import './dashboard.css';
import axios from 'axios';
import ShareButton from '../components/ShareButton';
import Companys from '../companys_root/companys';
import { MdSearch, MdAdd,MdSettings,MdKeyboardHide } from 'react-icons/md';
import Dashboarddata from './dashboard-data';
import Header from '../master_root/header';
import Navbar from '../master_root/Navbar';
import Footer from '../master_root/footer';
export default function Dashboard() {
    const navigate = useNavigate();
    const [guid, setGuid] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [Selected, setSelected] = useState('Dashboard');
  const [loginisOpen, setLoginIsOpen] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
 
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setGuid(existingUser);
      setLoginIsOpen(true);
    } else {
        navigate('/login');
      setLoginIsOpen(false);
    }
  }, []);

    return (
        <>
        <Header/>
        <br/>
            <div className='app_header_height'></div>
            <Helmet>
  <title>Dashboard - Manage Your Jobs & Creative Portfolio | EditorTask</title>

  <meta name="description" content="Access your EditorTask dashboard to manage job tasks, track freelance applications, and showcase your creative portfolio. Your gateway to new opportunities." />
  <meta name="keywords" content="editor dashboard, manage jobs, freelance dashboard, task tracking, creative portfolio, job management, EditorTask, India jobs platform, freelance India" />
  <meta name="author" content="EditorTask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Dashboard - Manage Jobs & Portfolio | EditorTask" />
  <meta property="og:description" content="Stay in control with the EditorTask dashboard. Post and track tasks, update your portfolio, and connect with top job opportunities in India." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/dashboard" />
  <meta property="og:image" content="https://www.editortask.com/assets/images/editortask_dashboard_preview.png" />

  <meta name="viewport" content="width=device-width, initial-scale=1" />
</Helmet>
 <div className='container_roots'>
        <div className='dashboard-body'>
            <div className="container_size">
                <div className='tabs-body'>
                    <div
                        onClick={() => setSelected('Dashboard')}
                        className={`tabsbutton ${Selected === 'Dashboard' ? 'active' : ''}`}
                        title="Dashboard"
                    >
                        <span className="tabs-text">Dashboard</span>
                    </div>
                    <div
                        onClick={() => setSelected('Companys')}
                        className={`tabsbutton ${Selected === 'Companys' ? 'active' : ''}`}
                        title="Companys"
                    >
                        <span className="tabs-text">Companys</span>
                    </div>

                    <div
                        onClick={() => setSelected('Saved')}
                        className={`tabsbutton ${Selected === 'Saved' ? 'active' : ''}`}
                        title="Saved"
                    >
                        <span className="tabs-text">Saved</span>
                    </div>
                </div>
                {/* Dashboard */}
                {Selected === 'Dashboard' && (
            <Dashboarddata/>
                )}

                {/* Companys */}
                {Selected === 'Companys' && (
                    <Companys />
                )}

                {/* History */}
                {Selected === 'History' && (
                    <>Saved</>
                )}
            </div>
     
        </div>
        <br/>
        </div>
            <Navbar/>
              <Footer/>
         </>
    );
}
